<template>
    <div class="nc-detail__row nc-detail__row_drivers" :class="{ 'is-open': showAll }">
        <span class="nc-detail__label">Водители:</span>
        <div class="nc-detail__drivers">
            <router-link
                v-for="driver in visibleDrivers"
                :key="driver.id"
                :to="getDriverRoute(driver)"
                class="nc-detail__driver-link"
                :class="{ 'nc-detail__driver-link_fired': driver.work_status === 'fired' }"
            >{{ driver.name }}</router-link>
        </div>
        <button
            v-if="drivers.length > 1"
            type="button"
            class="nc-detail__drivers-toggle"
            @click="showAll = !showAll"
        >
            <svg width="14" height="14"><use href="#icon-angle-down"/></svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'NewChatDrivers',
    props: {
        drivers: { type: Array, required: true },
    },
    data() {
        return { showAll: false }
    },
    computed: {
        visibleDrivers() {
            return this.showAll ? this.drivers : this.drivers.slice(0, 1)
        },
    },
    methods: {
        getDriverRoute(driver) {
            return { name: 'DriverDetail', query: { driver_id: driver.id, park_id: driver.park_id } }
        },
    },
}
</script>

<style lang="scss">
@import '../../../../../gulp-src/app/scss/_variables';

.nc-detail {
    &__row_drivers {
        align-items: flex-start;
    }

    &__drivers {
        display: flex;
        flex-direction: column;
        gap: 2px;
        flex: 1 1 auto;
        min-width: 0;
    }

    &__driver-link {
        display: block;
        font-size: 12px;
        line-height: 18px;
        font-weight: 500;
        color: $global-purple;
        text-decoration: none;
        word-break: break-word;

        &:hover {
            text-decoration: underline;
        }

        &_fired {
            color: #e94a4a;
        }
    }

    &__drivers-toggle {
        flex: 0 0 auto;
        background: none;
        border: none;
        padding: 2px;
        cursor: pointer;
        color: $global-light-gray-blue;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: color 0.15s ease, background 0.15s ease;

        svg {
            transition: transform 0.26s cubic-bezier(0.4, 0, 0.2, 1);
        }

        &:hover {
            color: $global-purple;
            background: $global-white-f6;
        }
    }

    &__row_drivers.is-open {
        .nc-detail__drivers-toggle svg {
            transform: rotate(180deg);
        }
    }
}
</style>